import { PureComponent, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import ShowMoreText from 'react-show-more-text';
import { bindActionCreators } from 'redux';
import { Formik, Form } from 'formik';
import moment from 'moment';

import {
  Button,
  Grid,
  Dropdown,
  Icon,
  Input,
  Modal,
  Segment,
  Table,
} from 'semantic-ui-react';

import { getOrgCoreDataInitialValues } from '../../../../validations/orgCoreDataValidation';
import { profileValidationSchemaWithDifferentNotes } from '../../../../validations/orgCoreDataValidation';
import { coreDataValidationSchema } from '../../../../validations/orgCoreDataValidation';

import {
  CustomDropdown,
  CustomTextArea,
  CustomFileUpload,
} from '../../../../components/form';

import {
  CustomSegment,
  CustomTable,
  EmptyContainer,
} from '../../../../components';

import {
  deleteOrganizationCoreData,
  getCoreDataInfo,
  updateCoreDataInfo,
  updateOrganizationInfo,
  uploadOrgAnnualReport,
} from '../../../../store/actions';

import { getReportYears, setValue } from '../../../../utils';
import { find, get, isEmpty, map } from '../../../../utils/lodash';
// import { getOrgProfileInitialValues } from '../../../../validations/orgProfileValidation';

import '../organization.scss';

class UpdateData extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      value: props.record.data ? props.record.data.value : '',
      valueError: '',
    };
  }

  changeEditState = async () => {
    let { edit, value } = this.state;
    let {
      t,
      coreData,
      index,
      reportYear,
      reportStart,
      reportEnd,
      updateCoreDataInfo,
    } = this.props;

    if (!edit) {
      this.setState({
        edit: !edit,
        value: this.props.record.data.value,
      });
    } else {
      if (!value) {
        this.setState({
          valueError: t('formulary.validation.expenditure_value_required'),
        });
      } else {
        value = `${value}`.replace(/,/g, '');
        var isNum = /^\d+$/.test(value);
        if (isNum) {
          coreData[index].data.value = parseInt(value);
          try {
            await updateCoreDataInfo({
              coreData: {
                dateRecorded: moment().format('YYYY-MM-DD'),
                inputs: coreData,
              },
              reportYear,
              reportStart,
              reportEnd,
            });
          } catch (error) {
            NotificationManager.error(t('utils.error.something_wrong'));
          }

          this.setState({
            edit: !edit,
          });
        } else {
          this.setState({
            valueError: t('formulary.validation.only_numbers_accepted'),
          });
        }
      }
    }
  };

  async onChange(value) {
    const { t } = this.props;
    value = value.replace(/,/g, '');
    let isNum = /^\d+$/.test(value);
    this.setState({
      valueError: !isNum ? t('formulary.validation.only_numbers_accepted') : '',
      value: value,
    });
  }

  render() {
    let { edit, value, valueError } = this.state;
    const { t, record } = this.props;

    return (
      <div className="coredata-edit-container">
        <div className="coredata-edit-area-container">
          {edit ? (
            <div className="coredata-edit-input-container">
              <Input
                type="text"
                className={`input ${valueError ? 'input-err' : ''}`}
                onChange={(e) => {
                  this.onChange(e.target.value);
                }}
                value={value}
              />
              <div
                className={valueError ? 'error-msg-div' : 'error-msg-hidden'}
              >
                {valueError}
              </div>
            </div>
          ) : (
            setValue(record.data)
          )}
        </div>
        <div className="coredata-edit-action-container">
          {edit ? (
            <div className="actions">
              <label
                className="coredata-update-text"
                onClick={this.changeEditState}
              >
                {t('actions.update')}
              </label>

              <label
                className="coredata-cancel-text"
                onClick={() => this.setState({ edit: !edit })}
              >
                {t('actions.cancel')}
              </label>
            </div>
          ) : (
            <label
              className="coredata-edit-text"
              onClick={this.changeEditState}
            >
              {t('actions.edit')}
            </label>
          )}
        </div>
      </div>
    );
  }
}

class OrganizationCoreData extends PureComponent {
  constructor(props) {
    super(props);
    this.year = new Date().getFullYear();
    this.state = {
      tmpCoreData: [],
      attachedReport: [],
      reportingYearsOptions: [],
      reportingYear: null,
      reportStart: null,
      reportEnd: null,
      modal: false,
      loading: false,
      removeModal: false,
      organization: [],
      orgForm: {},
      modalShow: false,
      file: null,
      imgPreView: null,
    };
  }
  setFile = async (file) => {
    this.setState({ file });
  };

  async componentWillMount() {
    try {
      await this.getReportingYears();

      const { reportingYear } = this.state;

      this.props.getCoreDataInfo(reportingYear);
    } catch (error) {
      // handle error
    }
  }

  async getReportingYears() {
    const { organisation } = this.props.auth.user;
    const { financialYear } = get(organisation, 'settings[0]');

    const isFinancial = financialYear || financialYear === undefined;

    const {
      auth: {
        user: {
          organisation: {
            createdDateTime: organisationStartDate = '2018-01-01',
          },
        },
      },
    } = this.props;

    const reportingYears = getReportYears(
      isFinancial,
      this.year,
      organisationStartDate
    );

    this.setState({
      reportingYearsOptions: reportingYears,
      reportingYear: reportingYears[0].value,
      reportStart: reportingYears[0].yearStart,
      reportEnd: reportingYears[0].yearEnd,
    });
  }

  setTableColumns(dataset) {
    if (isEmpty(dataset)) return null;
    return map(dataset, (item, i) => (
      <Table.Row key={i}>
        <Table.Cell>{item.input}</Table.Cell>
        <Table.Cell>
          <UpdateData
            coreData={dataset}
            record={item}
            index={i}
            reportYear={this.state.reportingYear}
            reportStart={this.state.reportStart}
            reportEnd={this.state.reportEnd}
            {...this.props}
          />
        </Table.Cell>
        <Table.Cell>{item.dataToCollect}</Table.Cell>
      </Table.Row>
    ));
  }

  optionYears() {
    const { reportingYearsOptions } = this.state;
    const data = reportingYearsOptions.map((item, key) => {
      return {
        key,
        value: item.value,
        text: item.text,
        rest: { key: item.value },
      };
    });
    return data;
  }
  onChange(type, value) {
    if (type === 'logo' && !!value.target.files[0]) {
      this.setState({
        file: value.target.files[0],
        imgPreView: value.target.files[0]
          ? window.URL.createObjectURL(value.target.files[0])
          : null,
      });
    }

    this.setState(
      (prevState) => ({
        orgForm: {
          ...prevState.orgForm,
          [type]: isNaN(value) ? value : Number(value),
        },
      }),
      () => {
        this.isSaved();
      }
    );
  }

  onChangeYearSelection(value) {
    const yearObj = find(this.state.reportingYearsOptions, {
      value,
    });
    const { updateOrganizationInfo, organization, getCoreDataInfo } =
      this.props;

    this.setState(
      {
        reportingYear: value,
        reportStart: yearObj.yearStart,
        reportEnd: yearObj.yearEnd,
      },
      async () => {
        try {
          await updateOrganizationInfo(
            {
              settings: [
                {
                  ...organization.settings[0],
                  defaultYear: value,
                },
              ],
            },
            false
          );
          getCoreDataInfo(this.state.reportingYear);
        } catch (error) {
          console.error(
            'OrganizationCoreData ~ onChangeYearSelection ~ error:',
            error
          );
        }
      }
    );
  }

  changeYearModal(value) {
    const yearObj = find(this.state.reportingYearsOptions, {
      value: value,
    });

    this.setState({
      reportingYear: value,
      reportStart: yearObj.yearStart,
      reportEnd: yearObj.yearEnd,
    });
  }

  openModal() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async onHandleSubmit(values) {
    try {
      this.setState({ loading: true });
      const { file, reportingYear } = this.state;
      const { uploadOrgAnnualReport, getCoreDataInfo } = this.props;

      let formData = new FormData();
      formData.set('document', file.file);
      formData.set('reportingYear', reportingYear);
      formData.set('notes', values.notes);
      await uploadOrgAnnualReport(formData);

      await getCoreDataInfo(reportingYear);
      this.setState({ loading: false });
      this.openModal();
    } catch (error) {
      console.error(
        'OrganizationCoreData -> handleValidSubmit -> error :',
        error
      );
    }
  }

  columns() {
    const { t } = this.props;

    return [
      {
        title: t('organisation.core_data.report_name'),
        width: 4,
        render: (data) => {
          let reportName = get(data.document, 'name', '');
          if (!isEmpty(reportName)) {
            reportName = reportName.split('.');
          }
          return (
            <div className="evidence-container">
              <label className="evidence-mainText">
                {' '}
                {!isEmpty(reportName) ? reportName[0].toUpperCase() : '-'}
              </label>
            </div>
          );
        },
      },
      {
        title: t('common.notes'),
        width: 6,
        render: (data) => {
          return (
            <div className="evidence-container">
              <label className="core-data-label">
                <ShowMoreText
                  lines={2}
                  more={t('common.read_more')}
                  less={t('common.read_less')}
                  anchorClass="show-more-less-clickable"
                  expanded={false}
                  truncatedEndingComponent={'... '}
                  className="pre-line"
                >
                  <p> {!isEmpty(data.notes) ? data.notes : '-'}</p>
                </ShowMoreText>
              </label>
            </div>
          );
        },
      },
      {
        title: t('organisation.core_data.format'),
        width: 2,
        render: (data) => {
          let format = get(data.document, 'name', '');
          if (!isEmpty(format)) {
            format = format.split('.');
          }
          return (
            <div className="evidence-container">
              <label className="core-data-label">
                {!isEmpty(format[1]) ? String(format[1]).toUpperCase() : '-'}
              </label>
            </div>
          );
        },
      },
      {
        title: t('common.date_added'),
        width: 2,
        render: (data) => {
          let date = get(data.document, 'updatedAt', '');
          date = moment(date).format('YYYY-MM-DD');
          return (
            <div className="evidence-container">
              <label className="core-data-label">
                {!isEmpty(date) ? date : '-'}
              </label>
            </div>
          );
        },
        with: '500',
      },
      {
        title: '',
        width: 1,
        render: (data) => {
          return (
            <div className="actions-core">
              <label
                onClick={() => window.open(data.document.documentUrl, '_blank')}
                className="core-download"
              >
                {t('actions.download')}
              </label>
              <DeleteCoreData
                reportYear={this.state.reportingYear}
                data={data}
                {...this.props}
              />
            </div>
          );
        },
      },
    ];
  }

  render() {
    if (isEmpty(this.props.orgCoreData)) return null;

    const {
      t,
      organization: { organization },
      orgLoading,
      orgCoreData: { coreData = {}, attachedDocuments = [] },
    } = this.props;

    const { modal, loading, isChecked } = this.state;

    return (
      <div>
        <CustomSegment
          tooltip={{
            user: this.props.user,
            helpTips: this.props.helpTips,
            id: '173',
          }}
          title={t('organisation.core_data.set_cultural_assets')}
          className="set-cultural-assets-and-budgeted-recurrent-expenditure"
          rightHeader={
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={8}
              textAlign="right"
              floated="right"
            >
              <div className="dropdown-selection">
                <Dropdown
                  className="archive-dropdown"
                  name="reportYear"
                  id="reportYear"
                  labelText={t('activity.core_data.reporting_year')}
                  options={this.optionYears()}
                  value={this.state.reportingYear}
                  placeholder={t('activity.core_data.select_reporting_year')}
                  onChange={(event, data) => {
                    this.onChangeYearSelection(data.value);
                  }}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: 'Reporting Year is required',
                    },
                  }}
                  selection
                  requiredStar
                  search
                />
              </div>
            </Grid.Column>
          }
          children={
            <div>
              <Segment className="content-segment" loading={orgLoading}>
                <Grid.Row className="report-section">
                  <Grid.Column
                    mobile={16}
                    tablet={8}
                    computer={8}
                    textAlign="left"
                  >
                    <div className="document-media-div">
                      <Button
                        className="Primary-Button"
                        onClick={() => this.openModal()}
                      >
                        {t('activity.core_data.upload_report')}
                      </Button>
                    </div>
                    <div className="add-user">
                      <Modal
                        size="small"
                        open={modal}
                        closeIcon={
                          <Icon
                            onClick={() => this.openModal()}
                            name="close"
                            className="closeicon"
                          />
                        }
                        className="upload-report-model"
                      >
                        <Modal.Header>
                          <label className="upload-media-header">
                            {t('activity.core_data.upload_report')}
                          </label>
                        </Modal.Header>
                        <Modal.Content className="core-data-upload">
                          <Segment
                            className="content-segment"
                            loading={loading}
                          >
                            <Formik
                              initialValues={getOrgCoreDataInitialValues(
                                organization
                              )}
                              onSubmit={(values, { resetForm }) => {
                                this.onHandleSubmit(values);
                                resetForm({ values: '' });
                              }}
                              validationSchema={
                                isChecked
                                  ? profileValidationSchemaWithDifferentNotes
                                  : coreDataValidationSchema(t)
                              }
                            >
                              {({
                                handleSubmit,
                                isSubmitting,
                                setFieldValue,
                              }) => (
                                <Form onSubmit={handleSubmit}>
                                  <div className="browse-files">
                                    <CustomFileUpload
                                      id="documentFile"
                                      name="documentFile"
                                      labelText={t(
                                        'activity.documentation.documents_and_media.document'
                                      )}
                                      accept=".pdf, .docx, .jpg, .jpeg, .png"
                                      buttonText={t('actions.browse_file')}
                                      mediaUpload={true}
                                      infoMessage={t(
                                        'organisation.settings.reference_form.max_file_size'
                                      )}
                                      setFile={this.setFile}
                                      showMsg={true}
                                      placeholder={t(
                                        'activity.documentation.documents_and_media.form.acceptedFileTypes'
                                      )}
                                      restrictedSize={2}
                                      setFieldValue={setFieldValue}
                                      loading={loading}
                                      disabled={loading}
                                      requiredStar
                                    />
                                  </div>

                                  <CustomDropdown
                                    name="reportYear"
                                    id="reportYear"
                                    labelText={t(
                                      'activity.core_data.reporting_year'
                                    )}
                                    options={this.optionYears()}
                                    value={this.state.reportingYear}
                                    placeholder={t(
                                      'activity.core_data.select_reporting_year'
                                    )}
                                    getValue={(value) => {
                                      this.changeYearModal(value);
                                    }}
                                    selection
                                    requiredStar
                                    search
                                  />
                                  <CustomTextArea
                                    name="notes"
                                    id="notes"
                                    className="org-inputs-textarea-notes"
                                    placeholder={t(
                                      'activity.core_data.enter_notes'
                                    )}
                                    labelText={t('common.notes')}
                                    getValue={(e) => this.onChange('notes', e)}
                                    requiredStar
                                  />
                                  <div className="model-buttons">
                                    <Button
                                      className="Secondary-Button"
                                      type="button"
                                      onClick={() => this.openModal()}
                                    >
                                      <div>{t('actions.cancel')}</div>
                                    </Button>

                                    <Button
                                      disabled={loading}
                                      loading={isSubmitting}
                                      type="submit"
                                      className="Primary-Button"
                                    >
                                      {t('actions.upload')}
                                    </Button>
                                  </div>
                                </Form>
                              )}
                            </Formik>
                          </Segment>
                        </Modal.Content>
                      </Modal>
                    </div>
                  </Grid.Column>
                </Grid.Row>

                <Grid className="core-data-grid" padded>
                  {/* <Grid.Row className="evidence-sector"> */}
                  <div className="core-text">
                    {t('activity.core_data.reference_documents')}
                  </div>
                  <CustomTable
                    header
                    columns={this.columns()}
                    data={attachedDocuments}
                    height={true}
                    emptyMessage={t(
                      'activity.core_data.no_reference_documents'
                    )}
                    customClass="core-data-reference-table"
                    keyExtractor={(item, index) => item.id}
                  />
                  {/* </Grid.Row>*/}
                </Grid>

                <Grid className="core-data-grid" padded>
                  {/* Inputs Table */}
                  <div className="table-holder">
                    <Table stackable basic="very" className="inputs-table">
                      <Table.Header className="inputs-table-head">
                        <Table.Row>
                          <Table.HeaderCell width={7}>
                            {t('activity.core_data.inputs')}
                          </Table.HeaderCell>
                          <Table.HeaderCell width={3}>
                            {t('activity.core_data.data')}
                          </Table.HeaderCell>
                          <Table.HeaderCell width={6}>
                            {t('activity.core_data.data_to_collect')}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {coreData && isEmpty(coreData.inputs) ? (
                          <Table.Row>
                            <Table.Cell colSpan={3}>
                              <EmptyContainer
                                msg={t('activity.core_data.no_inputs_found')}
                              />
                            </Table.Cell>
                          </Table.Row>
                        ) : (
                          this.setTableColumns(coreData.inputs)
                        )}
                      </Table.Body>
                    </Table>
                  </div>
                </Grid>
              </Segment>
            </div>
          }
        />
      </div>
    );
  }
}

class DeleteCoreData extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      removeModal: false,
      isChecked: false,
      organization: [],
      orgForm: {},
      modalShow: false,
      file: null,
      imgPreView: null,
    };
    this.fileInputRef = createRef();
  }

  removeToggle() {
    this.setState((prevState) => ({
      removeModal: !prevState.removeModal,
    }));
  }

  async handleCoreDataRemove(data) {
    const { deleteOrganizationCoreData, organization, reportYear } = this.props;
    await deleteOrganizationCoreData(
      organization.id,
      data.id,
      data.documentId,
      reportYear
    );
    this.removeToggle();
  }

  render() {
    const { t, coreDataDelete, data } = this.props;
    const { removeModal } = this.state;

    return (
      <Modal
        open={removeModal}
        onOpen={() => this.removeToggle()}
        onClose={() => this.removeToggle()}
        size="tiny"
        trigger={<label className="core-remove">{t('actions.remove')}</label>}
      >
        <Modal.Header className="modal-header-font">
          {t('organisation.core_data.delete_doc_in_core_data')}
        </Modal.Header>
        <Modal.Content>
          <p>{t('organisation.core_data.confirm_delete_doc')}</p>
        </Modal.Content>
        <Modal.Actions>
          <div className="model-buttons">
            <Button
              onClick={() => this.removeToggle()}
              className="Primary-Button"
            >
              {t('actions.no')}
            </Button>
            <Button
              onClick={() => this.handleCoreDataRemove(data)}
              className="Secondary-Button"
              content={t('actions.yes')}
              loading={coreDataDelete}
              disabled={coreDataDelete}
            />
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    organization: state.organization.organization,
    orgLoading: state.organization.loading,
    orgCoreData: state.organization.orgCoreData,
    coreDataDelete: state.organization.coreDataDelete,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateOrganizationInfo,
      uploadOrgAnnualReport,
      updateCoreDataInfo,
      getCoreDataInfo,
      deleteOrganizationCoreData,
    },
    dispatch
  );
};

OrganizationCoreData = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(OrganizationCoreData));

export { OrganizationCoreData };
